import callApi from './partials/api';

import authorization from './partials/authorization';
import store from '@/store';

export default {
    // 訂單建立
    orderCreate({
        OrderGroup,
        VatNO,
        CreditCardNO,
        ValidDate,
        CVC,
        PayType,
        IsPrintInvoice,
        CarrierBarcode,
    }, cb) {
        callApi('post', `Order/OrderCreate`, cb, {
            data: {
                OrderGroup,
                VatNO,
                CreditCardNO,
                ValidDate,
                CVC,
                PayType,
                IsPrintInvoice,
                CarrierBarcode,
                companyId: store.getters['advancedSearch/companyId'],
            },
            ...authorization(),
        });
    },

    // 訂單查詢API
    queryOrder({
        OrderBTime,
        OrderETime,
        Keyword,
        PayType,
        CurrentPage,
        PerPage,
    }, cb, errcb) {
        callApi('post', `Order/QueryOrder`, cb, {
            data: {
                OrderBTime,
                OrderETime,
                Keyword,
                PayType,
                CurrentPage,
                PerPage,
                companyId: store.getters['advancedSearch/companyId'],
            },
            ...authorization(),
        }, errcb);
    },

    // 取消訂單查詢
    queryCancelOrder({
        OrderBTime,
        OrderETime,
        Keyword,
        PayType,
        CurrentPage,
        PerPage,
    }, cb, errcb) {
        callApi('post', `Order/QueryCancelOrder`, cb, {
            data: {
                OrderBTime,
                OrderETime,
                Keyword,
                PayType,
                CurrentPage,
                PerPage,
                companyId: store.getters['advancedSearch/companyId'],
            },
            ...authorization(),
        }, errcb);
    },

    // 訂單明細查詢API
    queryOrderDetail({
        OrderID,
        type
    }, cb) {
        callApi('post', `Order/QueryOrderDetail`, cb, {
            data: {
                OrderID,
                type,
                companyId: store.getters['advancedSearch/companyId']
            },
            ...authorization(),
        });
    },

    // 學員資料修改API
    editOrderStudent({
        OrderDetailID,
        Students
    }, cb) {
        callApi('post', `Order/EditOrderStudent`, cb, {
            data: {
                OrderDetailID,
                Students,
            },
            ...authorization(),
        });
    },

    // 取消報名
    cancelOrder({
        OrderDetailID,
        BankID,
        BankAccount,
        BankAccountName,
    }, cb, errCb) {
        callApi('post', `Order/CancelOrder`, cb, {
            data: {
                OrderDetailID,
                BankID,
                BankAccount,
                BankAccountName,
                companyId: store.getters['advancedSearch/companyId'],
            },
            ...authorization(),
        }, errCb);
    },
    
    // 取得銀行資料
    bankList(cb) {
        callApi('get', `Order/BankList`, cb);
    },
    
    // 檢查Token有無過期
    checkUser(cb) {
        callApi('post', `Order/CheckUser`, cb, {
            ...authorization(),
        });
    },
    // Trpg訂單第二段邏輯
    updateTspgOrder(bankOrderId, bankCode, bankResponseMessage , cb) {
        callApi('post', `Order/tspg-order`, cb, {
            data: {
                bankOrderId,
                bankCode,
                bankResponseMessage,
            },
            ...authorization(),
        })
    }
}
